import { METRIC_INFO } from "../../constants";
import createBuildTypes from "../types/build-type";
import { config } from "../../config/config";
import endpoints from "../../endpoints/endpoints";
import { createBuildRequest } from "../../model/http-json";

export const createBuild = (
  categoryId: string,
  projectId: string,
  values: createBuildRequest
) => ({
  type: createBuildTypes.CREATE_BUILD,
  http: {
    cognito: {
      effect: {
        url: config.BASE_URL + endpoints.buildEndpoint(categoryId, projectId),
        method: "POST",
        json: values,
      },
      // action to dispatch when effect succeeds:
      commit: {
        type: createBuildTypes.CREATE_BUILD_COMMIT,
        log: {
          initiative: METRIC_INFO.INITIATIVE_RF,
          feature: METRIC_INFO.BUILD,
        },
      },
      // action to dispatch if network action fails permanently:
      rollback: {
        type: createBuildTypes.CREATE_BUILD_ROLLBACK,
        log: {
          initiative: METRIC_INFO.INITIATIVE_RF,
          feature: METRIC_INFO.BUILD,
        },
      },
    },
  },
});

export const resetCreateBuild = () => ({
  type: createBuildTypes.RESET_BUILD,
});
